const sendEmail = async (data = {}) => {
  const response = await fetch(process.env.REACT_APP_SENDMAIL_SERVER_URL, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  return await response;
};

export default sendEmail;
